<template>
  <div class="row">
    <div class="col-12">
      <label class="font-weight-bold d-block mb-2">Filtro de Filas</label>
      <div class="input-group queue-group">
        <div class="input-group-prepend">
          <span class="input-group-text icon-wrapper">
            <i class="fas fa-users fa-fw"></i>
          </span>
        </div>
        <div class="multiselect-wrapper">
          <multiselect 
            v-model="selectedQueues" 
            :options="filteredQueues" 
            :multiple="true" 
            :close-on-select="false"
            :clear-on-select="false" 
            :hide-selected="false" 
            :preserve-search="false" 
            :preselect-first="false"
            :searchable="true" 
            label="alias" 
            track-by="id" 
            placeholder="Todas as filas"
            @input="onQueuesChange">
            <template slot="noResult">Nenhuma fila encontrada!</template>
          </multiselect>
        </div>
      </div>
      <input type="hidden" name="queue" :value="selectedQueueValue">
      <input type="hidden" name="queueTouched" :value="queueTouchedValue">
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      userQueues: [],
      projects: [],
      selectedQueues: []
    };
  },
  computed: {
    filteredQueues() {
      return this.userQueues;
    },
    selectedQueueValue() {
      if (!Array.isArray(this.selectedQueues) || !this.selectedQueues.length) {
        return '*';
      }

      return this.selectedQueues
        .map(queue => queue && (queue.id || queue.name))
        .filter(Boolean)
        .join(',');
    },
    queueTouchedValue() {
      return Array.isArray(this.selectedQueues) && this.selectedQueues.length > 0 ? '1' : '0';
    }
  },
  created() {
    this.getInitialData();
  },
  methods: {
    async getInitialData() {
      await Promise.all([this.getUserQueues(), this.getProjects()]);
      this.onQueuesChange();
    },
    getUserQueues() {
      return axios.get("/dashboard/getQueuesByUser").then(response => {
        this.userQueues = Array.isArray(response.data) ? response.data : [];
      }).catch(error => {
        console.error(error);
      });
    },
    getProjects() {
      return axios.get("/listProjectsByUser").then(response => {
        this.projects = Array.isArray(response.data) ? response.data : [];
      }).catch(error => {
        console.error(error);
      });
    },
    onQueuesChange() {
      this.$nextTick(() => {
        const queueInput = document.querySelector('input[name="queue"]');
        const queueTouchedInput = document.querySelector('input[name="queueTouched"]');

        if (queueInput) {
          queueInput.value = this.selectedQueueValue;
        }

        if (queueTouchedInput) {
          queueTouchedInput.value = this.queueTouchedValue;
        }
      });
    }
  }
};
</script>
<style>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.queue-group {
  display: flex;
  align-items: stretch;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background-color: #228899;
  color: white;
  border-radius: 0.25rem 0 0 0.25rem;
  height: 100%;
}

.multiselect-wrapper {
  flex: 1;
  min-width: 0;
}

.multiselect {
  width: 100%;
}

.multiselect__tags {
  min-height: 38px;
  border-radius: 0 0.25rem 0.25rem 0;
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
  background: #fff;
}

.multiselect__select {
  height: 38px;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.multiselect__option--highlight {
  background: #228899;
}

.multiselect__option--selected {
  background: #228899;
  color: #fff;
}

.multiselect__tag {
  background: #228899;
}

.multiselect__tag-icon:after {
  color: #228899;
}
</style>